import apiClient from '@u/apiClient'
import GetCreateVarianteController from '@/wayfinder/actions/App/Http/Controllers/Item/GetCreateVarianteController'
const base_errors = {}
function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async createItemVariante({ commit }, payload) {
    apiClient
      .route(GetCreateVarianteController.put({ item: payload.item }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setItem', response.data.item)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  }
}
